import jQuery from 'jquery';
import slick from 'slick-slider';

jQuery(function ($) {
    $('#remindMeForm').submit(function () {
        $.post('handler.php', {
            'userinfo': $('input[name="userinfo"]').val()
        }, function (responce) {
            if (responce.success) {
                $('#remindMeForm').html('<div class="alert alert-success">' + responce.msg + '</div>');
            } else {
                $('.alert.alert-error').remove();
                $('#remindMeForm').append('<div class="alert alert-error">' + responce.msg + '</div>');
            }
        }, 'json');
        return false;
    });

    $('#videoBtn').click(function () {
        /* $(this).closest('.video-wrapper').find('iframe').css({opacity: 1, visibility: 'visible'}); */
        $(this).closest('.video-wrapper').find('video').get(0).play();
        $(this).hide();
    });

    $('#videoBtnMob').click(function () {
        /* $(this).closest('.video-wrapper').find('iframe').css({opacity: 1, visibility: 'visible'}); */
        $(this).closest('.video-wrapper').find('video').get(0).play();
        $(this).hide();
    });

    $('.tabs-wrapper .nav-item').click(function () {
        $('.tabs-wrapper .nav-item').removeClass('active').attr('aria-selected', 'false');
        $('.tabs-wrapper .tab-pane').removeClass('show active');
        $(this).addClass('active').attr('aria-selected', 'true');
        $('#' + $(this).data('target')).addClass('show active');
    });

    var $width = $(window).width();
    if ($width <= 768) {
        $('#priceList').slick({
            slidesToShow: 1,
            dots: true
        });
    }

    $(window).resize(function () {
        var $width = $(window).width();
        if ($width <= 768) {
            $('#priceList').slick({
                slidesToShow: 1,
                dots: true
            });
        }
    });

    const jsonUrl = '../photo_json.php';
    const selGalWrap = '#galleryGrid';
    const selGal = '#galleryGrid .gallery';
    const selModal = '#galleryModal';
    const selSlider = '#galleryModal .gallery-slider';
    const selSliderItems = '.gallery .gallery-item';
    let step;
    let numSlides;

    function galleryGrid(incr, base) {
        const gallery = $(selGalWrap);
        if (gallery.length) {
            let items = [];
            numSlides = $(base).length;
            $.each(base, function (i, item) {
                let authorName = (item.author.trim().length === 0) ? '' : `<span>автор</span><br><span>${item.author}</span>`;
                items.push("<figure class='gallery-item' data-order='" + i + "' tabindex='0'><img src='" + item.filename + "' alt='Фото з лавандого парку Порадів'><figcaption>" + authorName + "</figcaption></figure>");
                if (i === incr) {
                    step = incr;
                    return false;
                }
            });

            $("<div/>", {
                "class": "gallery",
                html: items.join("")
            }).appendTo(gallery);
        }
    }

    function galleryGridMore(incr, base) {
        const gallery = $(selGal);
        if (gallery.length) {
            let items = [];
            $.each(base, function (i, item) {
                if (i <= step) return;
                let authorName = (item.author.trim().length === 0) ? '' : `<span>автор</span><br><span>${item.author}</span>`;
                items.push("<figure class='gallery-item' data-order='" + i + "' tabindex='0'><img src='" + item.filename + "' alt='Фото з лавандого парку Порадів'><figcaption>" + authorName + "</figcaption></figure>");
                if (i === step + incr || i === false) {
                    return false;
                }
            });
            step = step + incr;
            $(items.join("")).appendTo(gallery);
        }
    }

    function gallerySlider(base) {
        const gallery = $(selGalWrap);
        const modalSlider = $(selSlider);
        if (gallery.length) {
            let slider = [];
            numSlides = $(base).length;
            $.each(base, function (i, item) {
                let authorName = (item.author.trim().length === 0) ? `` : `<span class="desc">автор</span><br><span>${item.author}</span>`;
                let authorLink = (item.author_link.trim().length === 0) ? `${authorName}` : `<span class="desc">автор</span><br><a href="${item.author_link}" target="_blank"><span>${(item.author.trim().length === 0) ? item.author_link : item.author}</span></a>`;
                let modelName = (item.model.trim().length === 0) ? `` : `<br><span class="desc">модель</span><br><span>${item.model}</span>`;
                let modelLink = (item.model_link.trim().length === 0) ? `${modelName}` : `<br><span class="desc">модель</span><br><a href="${item.model_link}" target="_blank"><span>${(item.model.trim().length === 0) ? item.model_link : item.model}</span></a>`;
                slider.push("<figure class='slider-item' data-slide-order='" + i + "'><img src='" + item.filename + "' alt='Фото з лавандого парку Порадів'><figcaption>" + authorLink + modelLink + "</figcaption></figure>");
            });

            if (modalSlider.length) {
                $(slider.join("")).appendTo(modalSlider);
            }
        }
    }

    function galleryItemsListener() {
        $(selSliderItems).click(function () {
            const getNum = $(this).data('order');
            const modal = $(selModal);
            if (modal.length) {
                $('body').css({'overflow': 'hidden'});
                $(modal).show();
                $(modal).find('.gallery-slider').slick({
                    slidesToShow: 1,
                    initialSlide: getNum,
                    prevArrow: $('.btn-nav--prev'),
                    nextArrow: $('.btn-nav--next'),
                    accessibility: true,
                });
                $(document).on('keydown', function(e) {
                    if($(modal).find('.slick-slider').length) {
                        if(e.keyCode == 37) {
                            $(modal).find('.gallery-slider').slick('slickPrev');
                        }
                        if(e.keyCode == 39) {
                            $(modal).find('.gallery-slider').slick('slickNext');
                        }
                    }
                });
            }
        });
    }

    function checkSlQ(el, limit) {
        const num = $(selSliderItems).length;
        if (num >= limit) {
            el.hide();
        }
    }

    function closeModal(sel) {
        const modal = $(sel);
        $('body').css({'overflow': 'unset'});
        $(modal).hide();
        $(modal).find('.gallery-slider').slick('unslick');
    }

    $(document).ready(function () {
        let getImgs;
        $.ajax({
            dataType: 'json',
            url: jsonUrl,
            async: false,
            success: function (data) {
                getImgs = data;
            },
        }).fail(function() {
            getImgs = [{filename:"/img/logo.png", author:"", author_link:"", model:"", model_link:""}];
        });

        galleryGrid(5, getImgs);
        gallerySlider(getImgs);
        setTimeout(galleryItemsListener, 2000);

        const btnMore = $('#btnLoadMore');
        btnMore.click(function () {
            galleryGridMore(6, getImgs);
            setTimeout(galleryItemsListener, 2000);
            setTimeout(function () {
                checkSlQ(btnMore, numSlides);
            }, 2000);
        });


        $('.btn-close-modal').click(function () {
            closeModal(selModal);
        });

        $(document).on('keydown', function (event) {
            if (event.key == "Escape") {
                const modal = $(selModal);
                if($(modal).find('.slick-slider').length) {
                    closeModal(selModal);
                }
            }
        });
    });
});
